import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import AppRoutes from './AppRoutes';
import './config/i18n';
import 'styles/body.scss'
import WebFont from 'webfontloader';
import { RecoilRoot } from "recoil"

WebFont.load({
   google: {
     families: ['Roboto:300,400,500,700']
   }
});

ReactDOM.render(
  <RecoilRoot>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
